import React from "react";
import { useLocation } from "react-router-dom";
import ViolentDetailInfo from "../../components/Detail/_ViolentDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

  
function ViolentDetail() {
    let query = useQuery();

    return (
        <div>
            <ViolentDetailInfo ID={query.get("ID")} department={query.get("Dept")}/>
        </div>
    );
}

export default ViolentDetail;